export const login_locale = {
    TITLE: "Login",
    BUTTON: "login",
    EMAIL: "Email",
    ERROR_DURING_LOGIN: "An error occurred while attempted to log you in. Please try again."
};